<template>
    <div>
        <p class="label">{{ label }}</p>
        <MultiplePickerInput :value="value" @input="onInput" :items="items" v-bind="$attrs" />
    </div>
</template>

<script>
  import MultiplePickerInput from '@/components/inputs/MultiplePickerInput.vue';

  export default {
    name: "AlternanceMultiplePickerInput",
    components: {
      MultiplePickerInput,
    },
    props: {
      value: Array,
      label: { type: String, default: 'Alternance'}
    },
    data() {
      return {
        items: [
          {'id': 1 , 'name': 'Oui' },
          {'id': 0 , 'name': 'Non' }
        ],
      }
    },
    created() {
      this.loadListItem();
    },
    methods: {
      loadListItem() {
        const _this = this;

      },
      onInput(event) {
        this.$emit('input', event);
      }
    },
  }
</script>

<style scoped>

</style>
